import { ReactiveVar } from '@apollo/client';
import { Organization } from '../../../generated/graphql';

export default function setLastAccessedOrganization(lastAccessedOrganizationVar: ReactiveVar<Organization | null>) {
  return (organization: Organization) => {
    lastAccessedOrganizationVar(organization ?? null);
    if (organization !== undefined) localStorage.setItem('lastAccessedOrganization', JSON.stringify(organization));
  };
}
